import React from "react";
import { Card, Spinner } from "../../../shared";
import WidgetRegistry from "./WidgetRegistry";

const getWidgetClassName = (widget) => {
  if (widget?.type === "kpi") return "col-span-1";
  return "col-span-1 md:col-span-2";
};

const DashboardRenderer = ({ resolvedDashboard, loading }) => {
  const widgets = resolvedDashboard?.widgets || [];

  if (loading) {
    return (
      <div className="flex min-h-[320px] items-center justify-center">
        <Spinner size="xl" />
      </div>
    );
  }

  if (!widgets.length) {
    return (
      <Card className="rounded-lg">
        <div className="text-sm font-semibold text-gray-700">
          No widgets available
        </div>
        <div className="mt-2 text-sm text-gray-500">
          This dashboard has no widgets available for your role or current tier.
        </div>
      </Card>
    );
  }

  return (
    <div className="grid grid-cols-1 gap-3 md:grid-cols-2 xl:grid-cols-4">
      {widgets.map((widget) => (
        <div key={widget.widgetId} className={getWidgetClassName(widget)}>
          <WidgetRegistry widget={widget} loading={false} />
        </div>
      ))}
    </div>
  );
};

export default DashboardRenderer;
